import { DatameshEventType, DatameshFlow, DatameshIds } from './models';

export const getDatameshEventId = ({
  datameshEvent,
  datameshId,
  productTypes,
  datameshFlow,
}: {
  datameshEvent: DatameshEventType;
  datameshId: DatameshIds;
  datameshFlow: DatameshFlow;
  productTypes: string[];
}) => {
  return `${datameshEvent}::${datameshFlow}::${datameshId}::${productTypes.join(
    ','
  )}`;
};
